import { ShieldCheck, Award, Users, FileCheck, Clock, Star } from "lucide-react";

const STATS = [
  { icon: ShieldCheck, value: "1,000+", label: "Trademarks Filed", description: "Successfully filed trademark applications with the USPTO for businesses across all 50 states and a wide range of industries." },
  { icon: Award, value: "98%", label: "Success Rate", description: "Industry-leading approval rate on trademark applications, achieved through thorough pre-filing searches and precise application preparation." },
  { icon: Users, value: "500+", label: "Happy Clients", description: "Trusted by hundreds of businesses, entrepreneurs, and startups to protect their brand identity and intellectual property rights." },
  { icon: FileCheck, value: "2,500+", label: "Office Actions Resolved", description: "Successfully responded to and resolved thousands of USPTO office actions, helping clients overcome application challenges." },
  { icon: Clock, value: "10+", label: "Years of Experience", description: "Over a decade of dedicated expertise in US trademark registration, staying current with every USPTO policy update and procedural change." },
  { icon: Star, value: "4.9/5", label: "Client Rating", description: "Consistently rated as one of the top trademark registration services by our clients, reflecting our commitment to exceptional service." },
];

export default function TrustSignals() {
  return (
    <section
      id="trust-signals"
      data-testid="trust-signals-section"
      className="py-20 md:py-32 bg-[#0A0F1A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] mb-4">
            Our Track Record
          </span>
          <h2
            data-testid="trust-signals-heading"
            className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-white tracking-tight mb-4"
          >
            Numbers That Speak for Themselves
          </h2>
          <p className="text-slate-400 text-base sm:text-lg max-w-3xl mx-auto leading-relaxed">
            At Trademark Officers, our track record of success is built on years of dedicated service, deep expertise in USPTO procedures, and an unwavering commitment to protecting our clients' brands. These numbers reflect the trust businesses place in us and the consistent results we deliver.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {STATS.map((stat, i) => (
            <div
              key={stat.label}
              data-testid={`trust-stat-${i}`}
              className="bg-[#111827] border border-slate-800 rounded-lg p-7 hover:border-[#2563EB]/50 transition-all duration-300 group"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-lg bg-[#1E3A8A]/30 flex items-center justify-center shrink-0 group-hover:bg-[#1E3A8A] transition-colors">
                  <stat.icon className="w-5 h-5 text-[#2563EB] group-hover:text-white transition-colors" />
                </div>
                <div>
                  <div className="font-heading text-2xl font-extrabold text-white mb-1">
                    {stat.value}
                  </div>
                  <div className="font-heading text-sm font-semibold text-[#2563EB] mb-2">
                    {stat.label}
                  </div>
                  <p className="text-slate-400 text-xs leading-relaxed">{stat.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust badges bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-wrap justify-center gap-6 lg:gap-12">
            {[
              "USPTO Filing Experts",
              "1000+ Trademarks Filed",
              "98% Success Rate",
              "BBB Accredited",
              "Flat-Fee Pricing",
              "24/7 Online Support",
            ].map((badge) => (
              <div
                key={badge}
                className="flex items-center gap-2 text-slate-500 text-xs font-medium uppercase tracking-wider"
              >
                <ShieldCheck className="w-3.5 h-3.5 text-[#2563EB]" />
                {badge}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
